import type { OrderCartV2Line } from "../../services/redux/types/OrderCartV2Types";
import type { EntityImageLookup } from "../loyaltyTypes";
import type { SubItemType } from "../types";

// Cart lines carry menu uuids; receipt rejections and item status use numeric ids.
type SubItemLookup = Record<string, SubItemType>;

export const getLineMenuItemId = (
  line: OrderCartV2Line,
  subItemLookup: SubItemLookup,
  entityImageLookup: EntityImageLookup
): number | undefined => {
  const subItem = subItemLookup[line.subItemId];

  return (
    subItem?.item?.id ??
    subItem?.itemId ??
    entityImageLookup[line.itemId]?.itemId ??
    entityImageLookup[line.subItemId]?.itemId
  );
};

export const getLineIdsOfSubItems = (
  lines: OrderCartV2Line[],
  subItemLookup: SubItemLookup,
  subItems: Pick<SubItemType, "id" | "uuid">[]
): string[] => {
  const ids = new Set(subItems.map((subItem) => subItem.id));
  const uuids = new Set(subItems.map((subItem) => subItem.uuid));

  return lines.flatMap((line) => {
    const numericId = subItemLookup[line.subItemId]?.id;
    const rejected =
      uuids.has(line.subItemId) ||
      (numericId !== undefined && ids.has(numericId));

    return line.lineId && rejected ? [line.lineId] : [];
  });
};
